export const isObject = o => {
  return Object.prototype.toString.call(o) === '[object Object]';
};

export const isFunction = o => {
  return Object.prototype.toString.call(o) === '[object Function]';
};

let isNodeEnvAvailable, isProduction, isTest;

try {
  isNodeEnvAvailable = process && process.env && process.env.NODE_ENV;
  isProduction = isNodeEnvAvailable && process.env.NODE_ENV === 'production';
  isTest = isNodeEnvAvailable && process.env.NODE_ENV === 'test';
} catch (e) {
  isNodeEnvAvailable = false;
  isProduction = false;
  isTest = false;
}

export { isNodeEnvAvailable, isProduction, isTest };

// const isNodeEnvAvailable = process && process.env && process.env.NODE_ENV;

// export const isProduction =
//   isNodeEnvAvailable && process.env.NODE_ENV === 'production';

// export const isTest = isNodeEnvAvailable && process.env.NODE_ENV === 'test';
